import { render } from "./CustDataPetDataForm.vue?vue&type=template&id=15c28a0b&scoped=true&ts=true"
import script from "./CustDataPetDataForm.vue?vue&type=script&lang=ts"
export * from "./CustDataPetDataForm.vue?vue&type=script&lang=ts"

import "./CustDataPetDataForm.vue?vue&type=style&index=0&id=15c28a0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c28a0b"]])

export default __exports__